import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import VehiclePriceDetailsBlockTemplate from './VehiclePriceDetailsBlockTemplate';
export const VehiclePriceDetailsBlockStyled = styled(VehiclePriceDetailsBlockTemplate)`
    display: flex;
    flex-direction: column;
    padding: 0 0 ${rem('30px')} 0;

    .row {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: ${rem('18px')};

        @media (max-width: ${breakpoints.xs}px) {
            flex-direction: column;
        }

        .rowTitle {
            font-weight: bold;
            font-size: ${rem('14px')};
        }

        .info,
        .infoOptions {
            font-size: ${rem('14px')};
            line-height: 1.43;
            color: black;

            .infoIcon {
                margin: unset !important;
            }
        }

        .wrapper {
            display: flex;
            flex-direction: column;
            width: 80%;
            justify-content: space-between;

            @media (max-width: ${breakpoints.xs}px) {
                width: 100%;
            }

            .infoOptions {
                grid-template-columns: 1fr 0fr 1fr;
                width: 100%;
                gap: ${rem('16px')};
                display: grid;

                .price {
                    text-align: right;
                }
            }
        }

        .info {
            display: flex;
            width: 80%;
            justify-content: space-between;

            @media (max-width: ${breakpoints.xs}px) {
                width: 100%;
            }

            .txt {
                display: flex;
                flex-direction: column;
            }
        }
    }
`;
